import {
  FETCH_MATERIAL_TRANSFER,
  RESET_MATERIAL_TRANSFER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
  others: {},
};

const materialTransferView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MATERIAL_TRANSFER:
      return { data: action.payload, others: action.others };
    case RESET_MATERIAL_TRANSFER:
      return initialState;
    default:
      return state;
  }
};

export default materialTransferView;
